<template>
    <ds-modal
        :is-open="isOpen"
        class="send-test-sms-modal"
        size="xs"
        @close="close"
    >
        <h3 class="send-test-title">
            Send a test
        </h3>

        <ds-phone-input
            v-model="to"
            class="phone-input"
            required
            label="Phone number"
            :invalid="invalid"
            :submitted="submitted"
            @input="reset"
        >
            <template #error>
                {{ errorMessage }}
            </template>
        </ds-phone-input>

        <div class="actions">
            <ds-text-button
                data-qa="back-button"
                @click="close"
            >
                Go back
            </ds-text-button>

            <ds-button
                class="button-space"
                :loading="loading"
                data-qa="send-test-message-button"
                @click="sendTest"
            >
                Send
            </ds-button>
        </div>
    </ds-modal>
</template>

<script>
import axios from 'axios';

import { isValidNorthAmericaPhoneNumber } from '@/components/broadcast/utils/sms-utils';

export default {
    props: {
        isOpen: {
            type: Boolean,
            required: false,
        },

        from: {
            type: String,
            required: true,
        },

        message: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            to: '',
            invalid: false,
            submitted: false,
            loading: false,
            rateLimitingReached: false,
        };
    },

    computed: {
        errorMessage() {
            if (!isValidNorthAmericaPhoneNumber(this.to)) {
                return 'Please enter a valid phone number';
            }

            if (this.rateLimitingReached) {
                return 'Sorry, you\'ve exceeded your 30 free test messages for today.';
            }

            return '';
        },
    },

    methods: {
        reset() {
            this.submitted = false;
            this.invalid = false;
        },

        close() {
            this.$emit('close');
            this.reset();
        },

        async sendTest() {
            this.submitted = true;

            if (isValidNorthAmericaPhoneNumber(this.to)) {
                this.loading = true;

                try {
                    const { from, to, message } = this;

                    await axios.post('/app/automatedSmsFunnel/sendTest', {
                        from,
                        to,
                        message,
                    });

                    this.$toast({
                        message: `Test sent to ${this.to}`,
                    });

                    this.$emit('close');
                } catch (error) {
                    if (error.response.status === 403) {
                        this.rateLimitingReached = true;
                        this.invalid = true;
                    } else {
                        this.$toast({ message: 'Error sending test message' });
                    }
                }

                this.loading = false;
            } else {
                this.invalid = true;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    .actions {
        display: flex;
        justify-content: flex-end;
    }

    .button-space {
        @include margin-start($spacing-200);
    }

    .send-test-title {
        margin-bottom: $spacing-200;
    }
</style>
